import { defineStore } from 'pinia';

/**
 * Returns the default state for the reports store.
 * @returns {Object} The default state object.
 */
function getDefaultState() {
    return {
        dateRange: {
            start: null,
            end: null,
            compareStart: null,
            compareEnd: null
        },
        resolution: 'hourly',
        isLoadingReport: false
    };
}

export const useReportsStore = defineStore('reports', {
    state: () => ({
        ...getDefaultState()
    }),
    actions: {
        /**
         * Resets the store state to its default values.
         */
        resetStateAction() {
            this.$reset();
        },

        /**
         * Sets the date range via action.
         * @param {Object} params - Parameters object.
         * @param {string|null} params.start - The start date (ISO8601) or null.
         * @param {string|null} params.end - The end date (ISO8601) or null.
         * @param {string|null} params.compareStart - The comparison start date or null.
         * @param {string|null} params.compareEnd - The comparison end date or null.
         */
        setDateRange({ start, end, compareStart, compareEnd }) {
            this.dateRange.start = start;
            this.dateRange.end = end;
            this.dateRange.compareStart = compareStart;
            this.dateRange.compareEnd = compareEnd;
        },

        /**
         * Sets the resolution via action.
         * @param {Object} params - Parameters object.
         * @param {string} params.resolution - The new resolution value.
         */
        setResolution({ resolution }) {
            this.resolution = resolution;
        },

        /**
         * Sets the loading state for reports via action.
         * @param {boolean} isLoadingReport - True if a report is loading.
         */
        setIsLoadingReport(isLoadingReport) {
            this.isLoadingReport = isLoadingReport;
        },

        /**
         * Resets the store state via action.
         */
        resetState() {
            this.resetStateAction();
        }
    }
});
